<template>
  <div
    class="form__item"
    :class="fieldClasses"
  >
    <tg-form-label
      v-if="label"
      :for-name="`field-${name}`"
      :label="label"
      :info="info"
      :required="isRequired"
    />
    <input
      :id="`field-${name}`"
      :value="value"
      :placeholder="placeholder"
      :name="name"
      :type="type"
      :readonly="readonly"
      :maxlength="maxlength"
      class="form__input"
      v-bind="$attrs"
      @input="onInput"
      @blur="onBlur"
    >
    <tg-form-field-validation
      v-if="validation"
      :validation="validationValue"
      :validation-messages="validationMessages"
    />
    <tg-form-helper-text
      v-if="helper"
      :info-text="helper"
    />
  </div>
</template>

<script>
import TgFormFieldValidation from '../validation/TgFormFieldValidation';
import TgFormLabel from '~/components/common/form/fields/TgFormLabel';

import inputMixin from '~/mixins/inputMixin';
import TgFormHelperText from '~/components/common/form/fields/TgFormHelperText';

export default {
  name: 'TgFormInputText',

  components: {
    TgFormHelperText,
    TgFormLabel,
    TgFormFieldValidation,
  },

  mixins: [
    inputMixin,
  ],

  props: {
    type: {
      type: String,
      default: 'text',
    },
    value: {
      type: [String, Number],
      default: '',
    },
    maxlength: {
      type: [String, Number],
      default: null,
    },
  },
};
</script>
